import { NavigateToFirstResource, usePermissions } from 'ra-core'
import { Navigate } from 'react-router-dom'
import { Loading } from '@internal/ui-kit/components/admin/loading'
import type { UserScope } from '@internal/ui-kit/lib/userScopes'

const MARKETING_SCOPE: UserScope = 'marketing'

/**
 * Rendered at "/". A marketing-scoped user (HATCH-668's `marketingOnly` sidebar,
 * which only shows the Marketing category) lands on `discount-codes` instead of
 * the `orders` resource they can't see in nav; everyone else keeps the default
 * react-admin behavior of landing on the first registered resource.
 */
export function DefaultRedirect() {
  const { permissions, isPending } = usePermissions<string[]>()
  if (isPending) {
    return <Loading />
  }
  if (Array.isArray(permissions) && permissions.includes(MARKETING_SCOPE)) {
    return <Navigate to="/discount-codes" replace />
  }
  return <NavigateToFirstResource loading={Loading} />
}
